import { AIAgentName } from '~/features-swym/aura/interfaces/ai-agents'

/** User used to create the conversation */
export const AI_USER = 'svc_3dswym_copilot'
/** Fake username for isTyping and presence */
export const AI_USER_FOR_IS_TYPING = 'svc_3dswym_copilot_fake'
/** Displayed AI name in left panel / conversation */
export const AI_CONTEXT_NAME = 'Virtual Companions'
/** Displayed AI name in left panel / conversation */
export const AI_NAME = 'AURA'
/** Displayed AI name in CKEditor */
export const AI_NAME_SHORT = 'AURA'
/** AI Model to use */
export const AI_MODEL = 'TheBloke/Phind-CodeLlama-34B-v2-AWQ'
/** Timeout for the AI Assistant. */
export const AI_ASSISTANT_TIMEOUT = 60000 // 60s

/** AIAssistantInfra Agents available. */
export const AI_AGENTS = [
  {
    agent_name: AIAgentName.BRAINSTORM_IDEAS,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.EXTRACT_6WTAGS,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.FIX_SPELLING_AND_LANGUAGE,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.MAKE_LONGER,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.MAKE_SHORTER,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.OUTLINE,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.PROS_AND_CONS,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.SIMPLIFY,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.SUMMARIZE,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.TRANSLATE,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.WRITE_A_POST,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.WRITE_A_STORY,
    agent_version: '1.0.0',
  },
  {
    agent_name: AIAgentName.WRITE_AN_ESSAY,
    agent_version: '1.0.0',
  },
  // The following agents are available but not used in Swym for now:
  // {
  //   agent_name: AIAgentName.CHANGE_TONE,
  //   agent_version: '1.0.0',
  // },
  // {
  //   agent_name: AIAgentName.EXPLAIN,
  //   agent_version: '1.0.0',
  // },
  // {
  //   agent_name: AIAgentName.IMPROVE_WRITING,
  //   agent_version: '1.0.0',
  // },
  // {
  //   agent_name: AIAgentName.EDIT,
  //   agent_version: '1.0.0',
  // },
]
